import { DbtDocsState } from "./DbtDocsReducer";
import { useDbtDocsCollaborationSelector } from "./DbtDocsCollaborationProvider";
import ConversationHighlighter from "./ConversationHighlighter";
import { ConversationGroup } from "./conversations/context/types";

const ConversationsHighlighter = () => {
  const conversationGroups = useDbtDocsCollaborationSelector(state =>
    Object.values(state.conversations || {})
  ) as ConversationGroup[] | undefined;
  const codeblockLoaded = useDbtDocsCollaborationSelector(
    state => state.codeblockLoaded
  ) as boolean;
  const currentPage = useDbtDocsCollaborationSelector(
    state => state.currentPage
  ) as DbtDocsState["currentPage"];

  const conversationsInCurrentPage = conversationGroups?.filter(
    conversationGroup =>
      conversationGroup.meta.resource_type === currentPage.resourceType &&
      conversationGroup.meta.uniqueId === currentPage.name
  );

  if (!conversationsInCurrentPage?.length || !codeblockLoaded) {
    return null;
  }

  return (
    <>
      {conversationsInCurrentPage.map(conversationGroup => (
        <ConversationHighlighter
          conversationGroup={conversationGroup}
          key={conversationGroup.conversation_group_id}
        />
      ))}
    </>
  );
};

export default ConversationsHighlighter;
